<template>
  <LightBox>
    <FormHeading :h="5">
      {{ $tt('visa_type_info') }}
    </FormHeading>
    <v-divider class="mb-0" />
    <ProductInfo :product :urgency />
  </LightBox>
</template>

<script setup lang="ts">
import type { VisaForm, Product } from '~/types';

defineProps<{
  product: Product;
  urgency: VisaForm['urgency'];
}>();
</script>